import { Component, OnInit, Optional, Inject } from '@angular/core';
import { EditDialogsDbindexfldsService } from './edit-dialogs-dbindexflds.service';
import { DialogsAlertComponent } from '../../../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-dialogs-dbindexflds',
  templateUrl: './edit-dialogs-dbindexflds.component.html',
  styleUrls: ['./edit-dialogs-dbindexflds.component.scss']
})
export class EditDialogsDbindexfldsComponent implements OnInit {

  /** Subscripción para el guardado de un dbindexfld */
  $guardar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public editDialogsDbindexfldsService: EditDialogsDbindexfldsService,
              @Optional() private dialogRef: MatDialogRef<EditDialogsDbindexfldsComponent>,
              private translateService: TranslateService,
              private dialog: MatDialog) { this.editDialogsDbindexfldsService.build(); }

  ngOnInit() {
    this.editDialogsDbindexfldsService.init(this.data).subscribe(result => {
      console.log(this.data);
      this.loading = false;
    });
    this.defaultLabel = this.translateService.instant('TABLAS.no_hay_dbindexflds');
  }

  /**
  * @description
  * Guardar el Dbindexfld
  */
  guardar() {
    this.loading = true;
    this.$guardar = this.editDialogsDbindexfldsService.guardar().subscribe(value => {
      console.log(value);
      // -2: El número del dbindexfld está ausente
      // -1: El número del dbindexfld ya existe
      // false: Error al guardar
      if (value === -1 || value === false || value === -2) {
        this.errorApplicationsDefs('WARNINGS.error_nuevo');
      }
      this.loading = false;
    }, error => {
      console.log(error);
      this.errorApplicationsDefs('WARNINGS.error_nuevo');
      this.loading = false;
    });
  }

  /**
  * @description
  * Cierra el dialog dbindexflds
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
    let dbindexfld = this.editDialogsDbindexfldsService.dbindexflds;
    let original = this.editDialogsDbindexfldsService.originalDbindexflds;
    return this.editDialogsDbindexfldsService.compare(dbindexfld, original);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorApplicationsDefs(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

}
